export { default } from './DeleteColumnsHeader';
